import ConfirmationDialog from 'components/ReusableComponents/ConfirmationDialog'
import { CheckIcon } from 'components/ReusableComponents/Icons/Check'
import { CrossIcon } from 'components/ReusableComponents/Icons/Cross'
import LoadingIndicator from 'components/ReusableComponents/LoadingIndicator'
import { useState } from 'react'

import styles from './TryLoginDialog.module.scss'

const PmsLoginResultDialog = ({ isTryingLogin, onClose, data, brand, shortName }) => {
  const response = data ? JSON.parse(data?.debugInfo) : null
  const loginIssues = response?.Result?.DebugInfo
    ? JSON.parse(response?.Result?.DebugInfo)
    : null

  const isPasswordChanged = data?.debugInfo === null ? true : data?.isPasswordChanged

  const [isDetailsVisible, setIsDetailsVisible] = useState(false)

  function getError(response) {
    const message = response?.Message || response?.message || ''

    if (isPasswordChanged) {
      return (
        <div className={styles.problemGood}>
          <p className={styles.title}>
            Login succesful. Password has been changed and PMS sync started.
          </p>
        </div>
      )
    } else if (message.includes('Invalid username or password')) {
      return (
        <div className={styles.problemBad}>
          <p className={styles.title}>Username or password is wrong.</p>
          <p className={styles.description}>
            Solution: We need new credentials from the hotel.
          </p>
        </div>
      )
    } else if (message.includes('Password expired')) {
      return (
        <div className={styles.problemBad}>
          <p className={styles.title}>Password expired, but we can set a new password.</p>
          <p className={styles.description}>
            Solution: Contact developers to resolve this issue.
          </p>
        </div>
      )
    } else if (message.includes('did not reach all pages')) {
      return (
        <div className={styles.problemBad}>
          <p className={styles.title}>
            Login works, but PMS user cannot reach following pages:
          </p>
          <ul className={styles.list}>
            {Object.keys(loginIssues)
              .filter(k => !loginIssues[k])
              .map(k => (
                <li key={k}>{k}</li>
              ))}
          </ul>
          <p className={styles.description}>
            Solution: Contact hotel and make get the necessary access for PMS user
          </p>
        </div>
      )
    } else {
      return (
        <>
          <p className={styles.title}>Something went wrong with the login</p>
          <p className={styles.description}>{message}</p>
        </>
      )
    }
  }

  if (isTryingLogin) {
    return (
      <ConfirmationDialog
        theme="blacklist"
        title="Trying to login..."
        hasCloseButton={false}
        hasConfirmButton={false}
        maxWidth={700}
        onClose={() => onClose()}
      >
        <div className={styles.wrapper}>
          <LoadingIndicator longWaitingTreshold={120} inline={true} />
        </div>
      </ConfirmationDialog>
    )
  }

  return (
    <ConfirmationDialog
      theme="blacklist"
      title={
        isTryingLogin ? (
          'Trying to login...'
        ) : isPasswordChanged ? (
          <>
            <CheckIcon className={styles.titleIcon} /> Login was succesful {brand}{' '}
            {shortName}
          </>
        ) : (
          <>
            <CrossIcon className={styles.titleIcon} fill="#ff5e5e" /> Login test was
            failed for {brand} {shortName}
          </>
        )
      }
      hasCloseButton={!isTryingLogin}
      hasConfirmButton={!isTryingLogin}
      maxWidth={700}
      onClose={() => onClose()}
      confirmLink={isPasswordChanged ? '/' : null}
      positiveMessage={isPasswordChanged ? 'Go to home' : 'Close'}
    >
      <div className={styles.wrapper}>
        {isTryingLogin && <LoadingIndicator longWaitingTreshold={120} inline={true} />}
        {!isTryingLogin && (
          <div>
            {getError(response)}
            <p
              className={styles.seeDetailsButton}
              onClick={() => setIsDetailsVisible(s => !s)}
            >
              {isDetailsVisible ? 'Hide' : 'See'} details
            </p>
            {isDetailsVisible && (
              <p className={styles.tryLoginResponse}>
                {JSON.stringify(response, null, 4)}
              </p>
            )}
          </div>
        )}
      </div>
    </ConfirmationDialog>
  )
}

export default PmsLoginResultDialog
